import { AppAreaConfig, DomainConfig } from '@/funnels/@types'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

const femaleActivity: AppAreaConfig = {
	appArea: 'activity-female-v2',
	options: {
		userTags: ['activity'],
	},
	landing: {
		ids: ['loader-activity-f', 'age-activity-f'],
		route: {
			path: '/activity-f',
			name: 'female-activity-funnel',
		},
		overrides: [
			{
				matcher: {
					$and: {
						utm_content: /exercise|workout/,
						utm_campaign: /search|activitygs/,
					},
				},
				ids: ['creatives-exercise'],
			},
			{
				matcher: {
					$and: {
						utm_content: /excel/,
						utm_campaign: /demgen/,
					},
				},
				ids: ['creatives-demgen'],
			},
			{
				matcher: {
					lptype: 'female_funnel', // /activity-f?safe&lptype=female_funnel&lpid=
				},
				ids: ['dynamic-loader-female', 'dynamic-age-f-18-50'],
			},
		],
	},
	funnel: {
		id: 'ob-female-activity',
		route: {
			path: '/activity-f/ob/:page*',
			name: 'female-activity-onboarding',
		},
		slug: 'female-activity-v2',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-activity-f',
		overrides: [
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-activity-f-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const maleActivity: AppAreaConfig = {
	appArea: 'activity-male',
	options: {
		userTags: ['activity'],
	},
	landing: {
		ids: ['loader-activity-m', 'age-activity-m'],
		route: {
			path: '/activity-m',
			name: 'male-activity-funnel',
		},
		overrides: [
			{
				matcher: {
					lptype: 'male_funnel', // /activity-m?safe&lptype=male_funnel&lpid=
				},
				ids: ['dynamic-loader-male-dark', 'dynamic-age-18-50'],
			},
		],
	},
	funnel: {
		id: 'ob-male-activity',
		route: {
			path: '/activity-m/ob/:page*',
			name: 'male-activity-onboarding',
		},
		slug: 'male-activity',
		theme: 'navy',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-activity-m',
		overrides: [
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-activity-m-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-activity-m'],
	},
	upgrade: {
		routeName: null,
	},
}

const mainActivity: AppAreaConfig = {
	appArea: 'main-activity',
	landing: {
		ids: ['loader-activity', 'age-activity'],
		route: {
			path: '/activity',
			name: 'main-activity-funnel',
		},
		overrides: [
			{
				matcher: {
					$and: {
						utm_content: /exercise|workout/,
						utm_campaign: /search|activitygs/,
					},
				},
				ids: ['creatives-exercise'],
			},
			{
				matcher: {
					lptype: 'main_loader', // /activity?safe&lptype=main_loader&lpid=
				},
				ids: ['dynamic-loader', 'dynamic-age-18-50'],
			},
		],
	},
	funnel: {
		id: 'ob-activity-gender-selection',
		route: {
			path: '/activity/ob/:page*',
			name: 'activity-survey',
		},
		slug: 'main-activity',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		redirectTo: {
			sex: {
				male: { appArea: maleActivity },
				female: { appArea: femaleActivity },
			},
		},
	},
}

const pilatesFemale: AppAreaConfig = {
	appArea: 'activity-female-pilates',
	additionalCrmLinks: [
		{
			name: 'Link to Paywall (short plans)',
			routeName: 'plan-email-pilates',
		},
	],
	options: {
		userFlags: ['hasAccessToPilatesVideos'],
		userTags: ['pilates'],
	},
	landing: {
		ids: ['loader-pilates-f', 'age-pilates-f'],
		route: {
			path: '/pilates-f',
			name: 'female-pilates-funnel',
		},
		overrides: [
			{
				matcher: {
					$or: {
						utm_content: /dategen/,
						utm_term: /dategen/,
					},
				},
				ids: ['creatives-dategen-female-pilates', 'age-pilates-f'],
			},
			{
				matcher: {
					$and: {
						utm_campaign: /search/,
						utm_content: /wallpilates/,
					},
				},
				ids: ['creatives-search-wall-pilates', 'age-pilates-f'],
			},
			{
				matcher: {
					lptype: 'female_funnel', // /pilates-f?safe&lptype=female_funnel&lpid=
				},
				ids: ['dynamic-loader-female', 'dynamic-age-f-18-50'],
			},
		],
	},
	funnel: {
		id: 'ob-yoga-narrative-on-pilates',
		route: {
			path: '/pilates-f/ob/:page*',
			name: 'female-activity-pilates',
		},
		slug: 'activity-female-pilates',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-pilates-f-commitment',
		overrides: [
			{
				matcher: { country: 'us' },
				routeName: 'plan-pilates-f-commitment-us',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-pilates-f'],
	},
	upgrade: {
		routeName: 'special-upsale',
	},
}

const yogaFemale: AppAreaConfig = {
	appArea: 'activity-female-yoga',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-yoga-f', 'age-yoga-f'],
		route: {
			path: '/yoga-f',
			name: 'female-yoga-funnel',
		},
		overrides: [
			{
				matcher: {
					$or: {
						utm_content: /dategen/,
						utm_term: /dategen/,
					},
				},
				ids: ['creatives-dategen-female-yoga', 'age-yoga-f'],
			},
			{
				matcher: {
					lptype: 'female_funnel', // /yoga-f?safe&lptype=female_funnel&lpid=
				},
				ids: ['dynamic-loader-female', 'dynamic-age-40-80'],
			},
		],
	},
	funnel: {
		id: 'ob-female-activity-chair-yoga',
		route: {
			path: '/yoga-f/ob/:page*',
			name: 'female-activity-chair-yoga',
		},
		slug: 'female-activity-yoga',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-yoga-f',
		overrides: [
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-yoga-f-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-yoga-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const yogaFemaleAl: AppAreaConfig = {
	appArea: 'activity-female-yoga-al',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-yoga-f', 'age-yoga-f'],
		route: {
			path: '/yoga-f-al',
			name: 'female-yoga-funnel-al',
		},
	},
	funnel: {
		id: 'ob-female-activity-chair-yoga-al',
		route: {
			path: '/yoga-f-al/ob/:page*',
			name: 'female-activity-chair-yoga-al',
		},
		slug: 'activity-female-yoga-al',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-yoga-f-al',
	},
	upsell: {
		routeNames: ['upsell-yoga-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const walkingFemale: AppAreaConfig = {
	appArea: 'activity-female-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-walking-f', 'age-walking-f'],
		route: {
			path: '/walking-f',
			name: 'walking-funnel',
		},
		overrides: [
			{
				matcher: {
					$or: {
						utm_content: /dategen/,
						utm_term: /dategen/,
					},
				},
				ids: ['creatives-dategen-female-walking', 'age-walking-f'],
			},
			{
				matcher: {
					lptype: 'female_funnel', // /walking-f?safe&lptype=female_funnel&lpid=
				},
				ids: ['dynamic-loader-female', 'dynamic-age-40-80'],
			},
		],
	},
	funnel: {
		id: 'ob-female-activity-walking',
		route: {
			path: '/walking-f/ob/:page*',
			name: 'female-activity-walking',
		},
		slug: 'female-activity-walking',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-walking-f',
		overrides: [
			{
				matcher: { country: 'us' },
				routeName: 'plan-walking-f-us',
			},
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-walking-f-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-walking-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const walkingMale: AppAreaConfig = {
	appArea: 'activity-male-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-walking-m', 'age-walking-m'],
		route: {
			path: '/walking-m',
			name: 'male-walking-funnel',
		},
		overrides: [
			{
				matcher: {
					lptype: 'male_funnel', // /walking-m?safe&lptype=male_funnel&lpid=
				},
				ids: ['dynamic-loader-male-light', 'dynamic-age-40-80'],
			},
		],
	},
	funnel: {
		id: 'ob-male-activity-walking',
		route: {
			path: '/walking-m/ob/:page*',
			name: 'male-activity-walking',
		},
		slug: 'male-activity-walking',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-walking-m',
		overrides: [
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-walking-m-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-walking-m'],
	},
	upgrade: {
		routeName: null,
	},
}

const walkingMain: AppAreaConfig = {
	appArea: 'main-walking',
	landing: {
		ids: ['loader-walking', 'age-walking'],
		route: {
			path: '/walking',
			name: 'main-walking-funnel',
		},
		overrides: [
			{
				matcher: {
					$or: {
						utm_content: /dategen/,
						utm_term: /dategen/,
					},
				},
				ids: ['creatives-dategen-main-walking', 'age-walking'],
			},
			{
				matcher: {
					$and: {
						utm_content: /walk/,
						utm_source: /google/,
						utm_campaign: /search/,
					},
				},
				ids: ['creatives-spreadsheet-walking', 'age-walking'],
			},
			{
				matcher: {
					lptype: 'main_loader', // /walking?safe&lptype=main_loader&lpid=
				},
				ids: ['dynamic-loader', 'dynamic-age-40-80'],
			},
		],
	},
	funnel: {
		id: 'ob-walking-gender-selection',
		route: {
			path: '/walking/ob/:page*',
			name: 'walking-survey',
		},
		slug: 'main-walking',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			sex: {
				male: { appArea: walkingMale },
				female: { appArea: walkingFemale },
			},
		},
	},
}

const chairWorkoutsMale: AppAreaConfig = {
	appArea: 'activity-male-chair-workouts',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-chair-workouts-m', 'age-chair-workouts-m'],
		route: {
			path: '/chair-workouts-m',
			name: 'male-chair-workouts-funnel',
		},
		overrides: [
			{
				matcher: {
					lptype: 'male_funnel', // /chair-workouts-m?safe&lptype=male_funnel&lpid=
				},
				ids: ['dynamic-loader-male-light', 'dynamic-age-40-80'],
			},
		],
	},
	funnel: {
		id: 'ob-male-chair-workouts',
		route: {
			path: '/chair-workouts-m/ob/:page*',
			name: 'male-activity-chair-workouts',
		},
		slug: 'male-activity-chair-workouts',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-chair-workouts-m',
	},
	upsell: {
		routeNames: ['upsell-chair-workouts-m'],
		overrides: [
			{
				matcher: { country: 'us' },
				routeNames: ['upsell-yoga-m-us'],
			},
		],
	},
	upgrade: {
		routeName: null,
	},
}

const pilatesFemaleAl: AppAreaConfig = {
	appArea: 'activity-female-pilates-al',
	options: {
		userFlags: ['hasAccessToPilatesVideos'],
		userTags: ['pilates'],
	},
	landing: {
		ids: ['loader-pilates-f', 'age-pilates-f'],
		route: {
			path: '/pilates-f-al',
			name: 'female-pilates-funnel-al',
		},
	},
	funnel: {
		id: 'ob-female-pilates-al',
		route: {
			path: '/pilates-f-al/ob/:page*',
			name: 'female-activity-pilates-al',
		},
		slug: 'activity-female-pilates-al',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-pilates-f-al',
	},
	upsell: {
		routeNames: ['upsell-pilates-f'],
	},
	upgrade: {
		routeName: 'special-upsale',
	},
}

const walkingFemaleAl: AppAreaConfig = {
	appArea: 'activity-female-walking-al',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-walking-f', 'age-walking-f'],
		route: {
			path: '/walking-f-al',
			name: 'walking-funnel-al',
		},
	},
	funnel: {
		id: 'ob-female-activity-walking-al',
		route: {
			path: '/walking-f-al/ob/:page*',
			name: 'female-activity-walking-al',
		},
		slug: 'activity-female-walking-al',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-walking-f-al',
	},
	upsell: {
		routeNames: ['upsell-walking-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const femaleAsianPilates: AppAreaConfig = {
	appArea: 'activity-female-asian-pilates',
	landing: {
		ids: ['loader-asian-pilates-f', 'age-asian-pilates-f'],
		route: {
			path: '/asian-pilates-f',
			name: 'female-asian-pilates-funnel',
		},
	},
	funnel: {
		id: 'ob-female-asian-pilates',
		route: {
			path: '/asian-pilates-f/ob/:page*',
			name: 'female-activity-asian-pilates',
		},
		slug: 'activity-female-asian-pilates',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: pilatesFemale,
				page: 'main-goal',
			},
		},
	},
}

const femaleSeniorPilates: AppAreaConfig = {
	appArea: 'activity-female-senior-pilates',
	options: {
		userFlags: ['hasAccessToPilatesVideos'],
		userTags: ['pilates'],
	},
	landing: {
		ids: ['loader-pilates-f', 'age-senior-pilates-f'],
		route: {
			path: '/senior-pilates-f',
			name: 'female-senior-pilates-funnel',
		},
	},
	funnel: {
		id: 'ob-female-senior-pilates',
		route: {
			path: '/senior-pilates-f/ob/:page*',
			name: 'female-activity-senior-pilates',
		},
		slug: 'activity-female-senior-pilates',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: pilatesFemale,
				page: 'main-goal',
			},
		},
	},
}

const yogaMain: AppAreaConfig = {
	appArea: 'main-yoga',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-yoga', 'age-yoga'],
		route: {
			path: '/yoga',
			name: 'main-yoga-funnel',
		},
		overrides: [
			{
				matcher: {
					lptype: 'main_loader', // /yoga?safe&lptype=main_loader&lpid=
				},
				ids: ['dynamic-loader', 'dynamic-age-40-80'],
			},
			{
				matcher: {
					$and: {
						utm_campaign: /search/,
						utm_content: /yoga/,
					},
				},
				ids: ['creatives-search-yoga', 'age-yoga'],
			},
		],
	},
	funnel: {
		id: 'ob-yoga-gender-selection',
		route: {
			path: '/yoga/ob/:page*',
			name: 'yoga-survey',
		},
		slug: 'main-yoga',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		redirectTo: {
			sex: {
				male: { appArea: chairWorkoutsMale },
				female: { appArea: yogaFemale },
			},
		},
	},
}

const maleActivityCalisthenics: AppAreaConfig = {
	appArea: 'activity-male-calisthenics',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-calisthenics-m', 'age-calisthenics-m'],
		route: {
			path: '/activity-calisthenics-m',
			name: 'male-activity-calisthenics-funnel',
		},
	},
	funnel: {
		id: 'ob-male-activity-calisthenics',
		route: {
			path: '/activity-calisthenics-m/ob/:page*',
			name: 'male-activity-calisthenics-onboarding',
		},
		slug: 'male-activity-calisthenics',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-calisthenics-m',
	},
	upsell: {
		routeNames: ['upsell-calisthenics-m'],
	},
	upgrade: {
		routeName: null,
	},
}

const femaleActivityCalisthenics: AppAreaConfig = {
	appArea: 'activity-female-calisthenics',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-calisthenics-f', 'age-calisthenics-f'],
		route: {
			path: '/activity-calisthenics-f',
			name: 'female-activity-calisthenics-funnel',
		},
	},
	funnel: {
		id: 'ob-female-activity-calisthenics',
		route: {
			path: '/activity-calisthenics-f/ob/:page*',
			name: 'female-activity-calisthenics-onboarding',
		},
		slug: 'female-activity-calisthenics',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-calisthenics-f',
	},
	upsell: {
		routeNames: ['upsell-calisthenics-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const walkingJapaneseFemale: AppAreaConfig = {
	appArea: 'activity-female-walking-japanese',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['japanese_walking'],
	},
	landing: {
		ids: ['loader-walking-japanese-f', 'age-walking-japanese-f'],
		route: {
			path: '/walking-japanese-f',
			name: 'walking-japanese-funnel',
		},
	},
	funnel: {
		id: 'ob-female-activity-walking-japanese',
		route: {
			path: '/walking-japanese-f/ob/:page*',
			name: 'female-activity-walking-japanese',
		},
		slug: 'activity-female-walking-japanese',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: walkingFemale,
				page: 'body-focus-areas',
			},
		},
	},
}

const walkingJapaneseFemaleV2: AppAreaConfig = {
	appArea: 'activity-female-walking-japanese-v2',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['japanese_walking'],
	},
	landing: {
		ids: ['loader-walking-japanese-f-v2', 'age-walking-japanese-f-v2'],
		route: {
			path: '/walking-japanese-f-v2',
			name: 'walking-japanese-funnel-v2',
		},
	},
	funnel: {
		id: 'ob-female-activity-walking-japanese-v2',
		route: {
			path: '/walking-japanese-f-v2/ob/:page*',
			name: 'female-activity-walking-japanese-v2',
		},
		slug: 'activity-female-walking-japanese-v2',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-walking-japanese-f',
		overrides: [],
	},
	upsell: {
		routeNames: ['upsell-walking-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const femaleTaiChiWalking: AppAreaConfig = {
	appArea: 'activity-female-tai-chi-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking-f', 'age-tai-chi-walking-f'],
		route: {
			path: '/tai-chi-walking-f',
			name: 'tai-chi-walking-funnel',
		},
		overrides: [
			{
				matcher: {
					$or: {
						utm_content: /dategen/,
						utm_term: /dategen/,
					},
				},
				ids: ['creatives-dategen-female-tai-chi-walking', 'age-tai-chi-walking-f'],
			},
		],
	},
	funnel: {
		id: 'ob-female-tai-chi-walking',
		route: {
			path: '/tai-chi-walking-f/ob/:page*',
			name: 'female-activity-tai-chi-walking',
		},
		slug: 'activity-female-tai-chi-walking',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		redirectTo: {
			always: {
				appArea: walkingFemale,
				page: 'focus-area',
			},
		},
	},
}

const femaleTaiChiWalkingAl: AppAreaConfig = {
	appArea: 'activity-female-tai-chi-walking-al',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking-f', 'age-tai-chi-walking-f'],
		route: {
			path: '/tai-chi-walking-f-al',
			name: 'tai-chi-walking-funnel-al',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi-walking',
		route: {
			path: '/tai-chi-walking-f-al/ob/:page*',
			name: 'female-activity-tai-chi-walking-al',
		},
		slug: 'activity-female-tai-chi-walking-al',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: walkingFemaleAl,
				page: 'physical-build',
			},
		},
	},
}

const maleTaiChiWalking: AppAreaConfig = {
	appArea: 'activity-male-tai-chi-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking-m', 'age-tai-chi-walking-m'],
		route: {
			path: '/tai-chi-walking-m',
			name: 'tai-chi-walking-male-funnel',
		},
	},
	funnel: {
		id: 'ob-male-tai-chi-walking',
		route: {
			path: '/tai-chi-walking-m/ob/:page*',
			name: 'male-activity-tai-chi-walking',
		},
		slug: 'activity-male-tai-chi-walking',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			always: {
				appArea: walkingMale,
				page: 'focus-area',
			},
		},
	},
}

const femaleTaiChiWalkingV2: AppAreaConfig = {
	appArea: 'activity-female-tai-chi-walking-v2',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking-f', 'age-tai-chi-walking-f'],
		route: {
			path: '/tai-chi-walking-f-v2',
			name: 'tai-chi-walking-f-v2-funnel',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi-walking-v2',
		route: {
			path: '/tai-chi-walking-f-v2/ob/:page*',
			name: 'female-activity-tai-chi-walking-v2',
		},
		slug: 'activity-female-tai-chi-walking-v2',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-tai-chi-walking-f-v2',
	},
	upsell: {
		routeNames: ['upsell-tai-chi-walking-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const femaleTaiChiWalkingV2Al: AppAreaConfig = {
	appArea: 'activity-female-tai-chi-walking-v2-al',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking-f', 'age-tai-chi-walking-f'],
		route: {
			path: '/tai-chi-walking-f-v2-al',
			name: 'tai-chi-walking-f-v2-funnel-al',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi-walking-v2-al',
		route: {
			path: '/tai-chi-walking-f-v2-al/ob/:page*',
			name: 'female-activity-tai-chi-walking-v2-al',
		},
		slug: 'activity-female-tai-chi-walking-v2-al',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'pt-BR', 'it-IT', 'es-ES'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-tai-chi-walking-f-v2-al',
	},
	upsell: {
		routeNames: ['upsell-tai-chi-walking-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const taiChiWalkingMain: AppAreaConfig = {
	appArea: 'main-tai-chi-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking', 'age-tai-chi-walking'],
		route: {
			path: '/tai-chi-walking',
			name: 'main-tai-chi-walking-funnel',
		},
	},
	funnel: {
		id: 'ob-tai-chi-walking-gender-selection',
		route: {
			path: '/tai-chi-walking/ob/:page*',
			name: 'tai-chi-walking-survey',
		},
		slug: 'main-tai-chi-walking',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			sex: {
				male: { appArea: maleTaiChiWalking },
				female: { appArea: femaleTaiChiWalkingV2 },
			},
		},
	},
}

const printableWalkingFemale: AppAreaConfig = {
	appArea: 'female-printable-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-walking-f', 'age-printable-walking-f'],
		route: {
			path: '/printable-walking-f',
			name: 'printable-walking-funnel',
		},
	},
	funnel: {
		id: 'ob-female-printable-walking',
		route: {
			path: '/printable-walking-f/ob/:page*',
			name: 'female-printable-walking',
		},
		slug: 'female-printable-walking',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-printable-walking-f',
	},
	upsell: {
		routeNames: ['upsell-walking-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const calisthenicsMain: AppAreaConfig = {
	appArea: 'main-calisthenics',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-calisthenics', 'age-calisthenics'],
		route: {
			path: '/calisthenics',
			name: 'main-calisthenics-funnel',
		},
	},
	funnel: {
		id: 'ob-calisthenics-gender-selection',
		route: {
			path: '/calisthenics/ob/:page*',
			name: 'calisthenics-survey',
		},
		slug: 'main-calisthenics',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			sex: {
				male: { appArea: maleActivityCalisthenics },
				female: { appArea: femaleActivityCalisthenics },
			},
		},
	},
}

const maleMilitary: AppAreaConfig = {
	appArea: 'military-male',
	landing: {
		ids: ['loader-military-m', 'age-military-m'],
		route: {
			path: '/military-m',
			name: 'military-male-funnel',
		},
	},
	funnel: {
		id: 'ob-military-male',
		route: {
			path: '/military-m/ob/:page*',
			name: 'military-male-onboarding',
		},
		slug: 'military-male',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: maleActivityCalisthenics,
				page: 'how-much-walking',
			},
		},
	},
}

const maleTaiChiYoga: AppAreaConfig = {
	appArea: 'activity-male-tai-chi-yoga',
	options: {
		userTags: ['tai_chi_yoga'],
	},
	landing: {
		ids: ['loader-tai-chi-yoga-m', 'age-tai-chi-yoga-m'],
		route: {
			path: '/tai-chi-yoga-m',
			name: 'male-tai-chi-yoga-funnel',
		},
	},
	funnel: {
		id: 'ob-male-tai-chi-yoga',
		route: {
			path: '/tai-chi-yoga-m/ob/:page*',
			name: 'male-activity-tai-chi-yoga',
		},
		slug: 'activity-male-tai-chi-yoga',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-tai-chi-yoga-m',
	},
	upsell: {
		routeNames: ['upsell-tai-chi-yoga-m'],
	},
	upgrade: {
		routeName: null,
	},
}

const femaleTaiChi: AppAreaConfig = {
	appArea: 'activity-female-tai-chi',
	options: {
		userTags: ['tai_chi_walking'],
		userFlags: ['hasAccessToWalkingVideos'],
	},
	landing: {
		ids: ['loader-tai-chi-f', 'age-tai-chi-f'],
		route: {
			path: '/tai-chi-f',
			name: 'female-tai-chi-funnel',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi',
		route: {
			path: '/tai-chi-f/ob/:page*',
			name: 'female-activity-tai-chi',
		},
		slug: 'activity-female-tai-chi',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-tai-chi-f',
	},
	upsell: {
		routeNames: ['upsell-tai-chi-walking-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const taiChiMain: AppAreaConfig = {
	appArea: 'main-tai-chi',
	options: {
		userTags: ['tai_chi_walking'],
		userFlags: ['hasAccessToWalkingVideos'],
	},
	landing: {
		ids: ['loader-tai-chi', 'age-tai-chi'],
		route: {
			path: '/tai-chi',
			name: 'main-tai-chi-funnel',
		},
	},
	funnel: {
		id: 'ob-tai-chi-gender-selection',
		route: {
			path: '/tai-chi/ob/:page*',
			name: 'tai-chi-survey',
		},
		slug: 'main-tai-chi',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			sex: {
				male: { appArea: maleTaiChiYoga },
				female: { appArea: femaleTaiChi },
			},
		},
	},
}

const config: DomainConfig = {
	'/': mainActivity,
	'/activity': mainActivity,
	'/activity-f': femaleActivity,
	'/activity-m': maleActivity,
	'/pilates-f': pilatesFemale,
	'/pilates-f-al': pilatesFemaleAl,
	'/asian-pilates-f': femaleAsianPilates,
	'/senior-pilates-f': femaleSeniorPilates,
	'/yoga': yogaMain,
	'/yoga-f': yogaFemale,
	'/yoga-f-al': yogaFemaleAl,
	'/walking': walkingMain,
	'/walking-f': walkingFemale,
	'/walking-f-al': walkingFemaleAl,
	'/walking-japanese-f': walkingJapaneseFemale,
	'/walking-japanese-f-v2': walkingJapaneseFemaleV2,
	'/tai-chi-f': femaleTaiChi,
	'/tai-chi': taiChiMain,
	'/tai-chi-walking': taiChiWalkingMain,
	'/tai-chi-walking-f': femaleTaiChiWalking,
	'/tai-chi-walking-f-v2': femaleTaiChiWalkingV2,
	'/tai-chi-walking-f-v2-al': femaleTaiChiWalkingV2Al,
	'/tai-chi-walking-f-al': femaleTaiChiWalkingAl,
	'/tai-chi-walking-m': maleTaiChiWalking,
	'/printable-walking-f': printableWalkingFemale,
	'/walking-m': walkingMale,
	'/tai-chi-yoga-m': maleTaiChiYoga,
	'/chair-workouts-m': chairWorkoutsMale,
	'/calisthenics': calisthenicsMain,
	'/activity-calisthenics-m': maleActivityCalisthenics,
	'/activity-calisthenics-f': femaleActivityCalisthenics,
	'/military-m': maleMilitary,
}

export default config
